// 对axios进行二次封装 目的使用请求与响应拦截器
import axios from 'axios'
// 引入element-plus中的消息提示的组件ElMessage
import router from '../router'
import store from '../store'
import {token} from './test'

// 第一步：利用axios对象的create方法创建axios实例（配置其他的配置：基础路径、超时的时间等）
const request = axios.create({
    // 利用axios自定义配置
    // baseURL: process.env.VUE_APP_BASE_API,//ggbone,
     baseURL: '/api2',//ggbone,

})
// 第二步：request实例添加请求与响应拦截器-interceptors拦截器
request.interceptors.request.use((config) => {
    // 如果有 token 则将 token 放到请求头中
    console.log(store.state.token, 'token');

    config.headers.token = store.state.token
    config.headers.Authorization = store.state.token

    // config.headers.token = token
    // config.headers.Authorization = token
    // config配置对象中的headers属性请求头：经常用于给服务器端携带公共参数

    return config // 返回配置对象
})
// 第三步：响应拦截器
request.interceptors.response.use(
    (response) => {

        console.log(response, 'response');

        switch (response.data.code) {
            case 0 : {
                return response.data // 简化数据 只拿响应对象中的data数据，不用拿到所有数据组成的对象
            }
            case -1 : {
                setTimeout(()=> {

                }, 200)
                return response.data // 简化数据 只拿响应对象中的data数据，不用拿到所有数据组成的对象
            }
            case -4 : {
                setTimeout(()=> {

                }, 200)
                return response.data // 简化数据 只拿响应对象中的data数据，不用拿到所有数据组成的对象
            }
            case 600 : {
                setTimeout(()=> {

                }, 200)

                // token 失效：清除登录态，跳登录页（原代码引用了不存在的 mutation，已修正）
                localStorage.removeItem('token')
                localStorage.removeItem('meetingId')
                localStorage.removeItem('corId')
                store.commit('setToken', '')
                store.commit('_setMeetingId', '')
                store.commit('_setCorId', '')
                router.push('/auth/login')
                return response.data // 简化数据 只拿响应对象中的data数据，不用拿到所有数据组成的对象
            }
            default: {
                // ElMessage({type: 'error', message: response.data.msg})

                if (response.config.responseType === 'blob' && response.data) {

                } else  {

                }
                return response.data // 简化数据 只拿响应对象中的data数据，不用拿到所有数据组成的对象
            }
        }
    },
    (error) => {

        // 处理http网络错误
        // 定义一个变量：存储网络错误信息
        // http状态码
        // 提示错误信

        // 返回失败的promise 去终结Promise
        return Promise.reject(error)
    },
)
export default request
